import React from 'react';
import PropTypes from 'prop-types';
import { ShareMobileIcon } from '@paypalcorp/pp-react';
import { grey600 } from '@paypalcorp/pp-react-colors';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  iconLink: {
    cursor: 'pointer',
    marginRight: '0.375rem',
  },
});

function SocialShareMobile({ handleMobileClick, linkTitle, color = grey600 }) {
  return (
    <ShareMobileIcon
      onClick={handleMobileClick}
      className={`${css(styles.iconLink)}`}
      style={{ color }}
      title={linkTitle}
      role="link"
      tabIndex="0"
      data-testid="social-share-mobile"
      size="lg"
    />
  );
}

SocialShareMobile.propTypes = {
  handleMobileClick: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.color,
};

export default SocialShareMobile;
